<div [class.layer]="(isSphereOpen$ | async)" (click)="onShow()">
  <div class="closed-container" *ngIf="!(isSphereOpen$ | async)" @fadeInAnimation>
    <app-progress-heart class="" [size]="30" [percentage]="this.patientRelevantData?.totalPercentage"></app-progress-heart>
    <p class="text-info tw-flex tw-items-center">Desplegar esfera</p>
  </div>

  <div class="information" *ngIf="(isSphereOpen$ | async)" (click)="$event.stopPropagation();" @fadeInAnimation>
    <ng-scrollbar #scrollComponent class="my-scrollbar">
      <!--TODO: falta pasar los datos que devuelve el servidor -->
      <app-mini-sphere
        *ngIf="this.sphereType === this.sphereModeEnum.MINI; else completeSphereTpl"
        [patient]="patient"
        [levelActivity]="levelActivity"
        [options]="options"
        [patientRelevantDataMiniSphere]="patientRelevantDataMiniSphere"
        [sedentaryLevel]="sedentaryLevel"
        [userLogged]="userLogged"
        [loaded]="loadData"
        (redirectTo)="onRedirectTo($event)"
      ></app-mini-sphere>

      <ng-template #completeSphereTpl>
        <app-complete-record-sphere
          [patientRelevantData]="patientRelevantData"
          [patient]="patient"
          [userLogged]="userLogged"
          [marksEasyOrDifficult]="marksEasyOrDifficult"
          [sedentaryLevel]="sedentaryLevel"
          [levelActivity]="levelActivity"
          [loaded]="loadData"
          (redirectTo)="onRedirectTo($event)"
        ></app-complete-record-sphere>
      </ng-template>



      <!--<div class="container-loader tw-z-10" *ngIf="!loadData">
        <div class="loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>-->
    </ng-scrollbar>
  </div>
</div>
